/**
 * API Configuration for Audit Logs endpoints
 */

export const AUDIT_LOGS_API_CONFIG = {
    BASE_PATH: "/admin/audit-logs",
    ENDPOINTS: {
        LIST: "/admin/audit-logs/",
        DASHBOARD: "/admin/audit-logs/dashboard",
        CHARTS_SUCCESS_FAILURE: "/admin/audit-logs/charts/success-failure",
        CHARTS_TIME_SERIES: "/admin/audit-logs/charts/time-series",
        TOP_FAILED_USERS: "/admin/audit-logs/top/failed-users",
        TOP_FAILURE_REASONS: "/admin/audit-logs/top/failure-reasons",
        TOP_SOURCES: "/admin/audit-logs/top/sources",
        EXPORT: "/admin/audit-logs/export",
    },
    PAGINATION: {
        DEFAULT_PAGE: 1,
        DEFAULT_PER_PAGE: 50,
        MAX_PER_PAGE: 500,
    },
    TIME_RANGES: {
        LAST_HOUR: "last_hour",
        LAST_24_HOURS: "last_24_hours",
        LAST_7_DAYS: "last_7_days",
        LAST_30_DAYS: "last_30_days",
        CUSTOM: "custom",
    },
    INTERVALS: {
        HOUR: "hour",
        DAY: "day",
    },
    EXPORT_FORMATS: {
        CSV: "csv",
        EXCEL: "excel",
    },
} as const;

// No trailing slashes: FastAPI would redirect and the redirect can drop the auth header
export const ACTIVITY_LOGS_API_CONFIG = {
    ENDPOINTS: {
        LIST: "/admin/activity-logs",
        TOP_MENUS: "/admin/activity-logs/top-menus",
        TOP_USERS: "/admin/activity-logs/top-users",
        USER_MENUS: "/admin/activity-logs/user-menus",
        TOP_DOWNLOADS: "/admin/activity-logs/top-downloads",
        DAILY: "/admin/activity-logs/daily",
    },
    TOP_LIMIT: 20,
    // top-users is also used to count active users; the backend caps it at 100
    ACTIVE_USERS_LIMIT: 100,
    DEFAULT_RANGE_DAYS: 30,
} as const;
